import React, { useState, useEffect } from "react";
import axios from "axios";
import { API } from "@/App";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Table2, Plus } from "lucide-react";
import { NewSheetDialog } from "./NewSheetDialog";
import { STATUS } from "./sheetModel";

// Compact list of production sheets for a project (Project detail → Files tab).
export const ProductionSheetsCard = ({ projectId, customerId }) => {
  const navigate = useNavigate();
  const [sheets, setSheets] = useState([]);
  const [showNew, setShowNew] = useState(false);
  useEffect(() => {
    const query = projectId ? `project_id=${projectId}` : `customer_id=${customerId}`;
    axios.get(`${API}/production-sheets?${query}`).then(r => setSheets(r.data || [])).catch(() => {});
  }, [projectId, customerId]);

  return (
    <Card className="mb-6" data-testid="production-sheets-card">
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <CardTitle className="text-base flex items-center gap-2"><Table2 className="w-4 h-4 text-indigo-600" /> Production Sheets</CardTitle>
        <Button size="sm" variant="outline" onClick={() => setShowNew(true)} data-testid="project-new-sheet-btn"><Plus className="w-3.5 h-3.5 mr-1" /> New</Button>
      </CardHeader>
      <CardContent>
        {sheets.length === 0 ? <p className="text-sm text-slate-400">No cut lists yet for this job.</p> : (
          <ul className="divide-y">
            {sheets.map(s => { const st = STATUS[s.status] || STATUS.draft; return (
              <li key={s.sheet_id} className="py-2 flex items-center justify-between gap-2 cursor-pointer hover:bg-slate-50 -mx-2 px-2 rounded" onClick={() => navigate(`/production-sheets/${s.sheet_id}`)} data-testid={`project-sheet-${s.sheet_id}`}>
                <div className="min-w-0"><p className="text-sm font-medium truncate">{s.sheet_number} · {s.title}</p><p className="text-xs text-slate-500">{s.totals?.rows ?? 0} rows · {s.totals?.quantity ?? 0} pcs · {(s.dispatches || []).length} dispatch(es)</p></div>
                <span className={`text-[11px] px-2 py-0.5 rounded-full font-medium shrink-0 ${st.cls}`}>{st.label}</span>
              </li>
            ); })}
          </ul>
        )}
      </CardContent>
      <NewSheetDialog open={showNew} onOpenChange={setShowNew} projectId={projectId} customerId={customerId} />
    </Card>
  );
};
